export const excludeFields = (arr: any[], type?: 'consent') => {
  return type === 'consent'
    ? arr.filter((item) => item.type === 'checkbox')
    : arr.filter((item) => item.type !== 'checkbox');
};
